// Copyright 2020 Cartesi Pte. Ltd.
// Licensed under the Apache License, Version 2.0 (the "License"); you may not
// use this file except in compliance with the License. You may obtain a copy
// of the license at http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
// License for the specific language governing permissions and limitations
// under the License.
export class Event {
    constructor(type, params) {
        this.type = type;
        this.params = params;
    }
    getParams() {
        return this.params;
    }
    getType() {
        return this.type;
    }
}
Event.ENEMY_SPAWNED = 'enemy spawned';
Event.ENEMY_KILLED = 'enemy killed';
Event.ENEMY_HIT = 'enemy hit by bullet';
Event.ENEMY_GLUE_HIT = 'enemy hit by glue bullet';
Event.ENEMY_REACHED_EXIT = 'enemy reached exit';
Event.ACTIVE_NEXT_WAVE = 'active next wave';
Event.WAVE_OVER = 'wave over';
Event.GAME_OVER = 'game over';
Event.NO_ENEMIES_ON_STAGE = 'no enemies on stage';
Event.BULLET_SHOT = 'bullet shot';
Event.GLUE_BULLET_SHOT = 'glue bullet shot';
Event.LASER_SHOT = 'laser shot';
Event.MORTAR_SHOT = 'mortar shot';
Event.MINE_SHOT = 'mine shot';
Event.GLUE_SHOT = 'glue shot';
Event.GLUE_CONSUMED = 'glue consumed';
Event.ENEMIES_TELEPORTED = 'enemies teleported';
Event.REMOVE_BULLET = 'remove bullet';
Event.REMOVE_GLUE_BULLET = 'remove glue bullet';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2V2ZW50cy9FdmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxtQ0FBbUM7QUFFbkMsOEVBQThFO0FBQzlFLDZFQUE2RTtBQUM3RSwrREFBK0Q7QUFFL0Qsc0VBQXNFO0FBQ3RFLDRFQUE0RTtBQUM1RSwyRUFBMkU7QUFDM0UsMEVBQTBFO0FBQzFFLHFCQUFxQjtBQUVyQixNQUFNLE9BQU8sS0FBSztJQXdCZCxZQUFZLElBQVksRUFBRSxNQUFZO1FBQ2xDLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2pCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO0lBQ3pCLENBQUM7SUFFTSxTQUFTO1FBQ1osT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDO0lBQ3ZCLENBQUM7SUFFTSxPQUFPO1FBQ1YsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDO0lBQ3JCLENBQUM7O0FBbENzQixtQkFBYSxHQUFHLGVBQWUsQ0FBQztBQUNoQyxrQkFBWSxHQUFHLGNBQWMsQ0FBQztBQUM5QixlQUFTLEdBQUcscUJBQXFCLENBQUM7QUFDbEMsb0JBQWMsR0FBRywwQkFBMEIsQ0FBQztBQUM1Qyx3QkFBa0IsR0FBRyxvQkFBb0IsQ0FBQztBQUMxQyxzQkFBZ0IsR0FBRyxrQkFBa0IsQ0FBQztBQUN0QyxlQUFTLEdBQUcsV0FBVyxDQUFDO0FBQ3hCLGVBQVMsR0FBRyxXQUFXLENBQUM7QUFDeEIseUJBQW1CLEdBQUcscUJBQXFCLENBQUM7QUFDNUMsaUJBQVcsR0FBRyxhQUFhLENBQUM7QUFDNUIsc0JBQWdCLEdBQUcsa0JBQWtCLENBQUM7QUFDdEMsZ0JBQVUsR0FBRyxZQUFZLENBQUM7QUFDMUIsaUJBQVcsR0FBRyxhQUFhLENBQUM7QUFDNUIsZUFBUyxHQUFHLFdBQVcsQ0FBQztBQUN4QixlQUFTLEdBQUcsV0FBVyxDQUFDO0FBQ3hCLG1CQUFhLEdBQUcsZUFBZSxDQUFDO0FBQ2hDLHdCQUFrQixHQUFHLG9CQUFvQixDQUFDO0FBQzFDLG1CQUFhLEdBQUcsZUFBZSxDQUFDO0FBQ2hDLHdCQUFrQixHQUFHLG9CQUFvQixDQUFDIn0=